import React, { useRef, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Adjust path as needed
import swal from 'sweetalert';
import { OTPConfirm } from '../../../components/actions/auth';
import Loader from '../../../components/utils/Loader';

const Otp = () => {
  const inputRefs = useRef([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '']);
  const [error, setError] = useState('');
  const [timer, setTimer] = useState(300);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(countdown);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  const onChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/^[0-9]$/) || value === '') {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value !== '' && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }
      if (value !== '' && index === 3) {
        inputRefs.current[0]?.focus();
      }
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.includes('')) {
      setError('Please enter all OTP digits');
      return;
    }

    setLoading(true);
    const code = sessionStorage.getItem('code');
    const otpCode = otp.join('');
    const res = await OTPConfirm(otpCode, code);
    setLoading(false);

    if (res?.message === 'success') {
      swal({
        position: 'center',
        icon: 'success',
        title: 'OTP verified successfully!',
        timer: 2000,
      });
      navigate('/login');
      setOtp(['', '', '', '']);
    } else {
      swal({
        position: 'center',
        icon: 'error',
        title: res?.message || 'Invalid OTP',
        timer: 2000,
      });
      setError(res?.message || 'Invalid OTP');
    }
  };

  const handleResendOtp = () => {
    setTimer(300);
    setIsResendDisabled(true);
    setOtp(['', '', '', '']);
    setError('');
    swal({
      position: 'center',
      icon: 'success',
      title: 'OTP resent successfully!',
      timer: 2000,
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      {loading && <Loader />}
      <div className="max-w-2xl w-full bg-white rounded-xl shadow-lg p-8 my-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img
              src="https://static.readdy.ai/image/7af4f58ae05219e4e22c1572ddc1f3d7/d032d822541faaab353be17129fb1467.png"
              alt="PrimeX Loyalty"
              className="w-10 h-10 object-contain"
            />
          </div>
          <h2 className="text-2xl font-semibold text-gray-800">OTP Verification</h2>
          <p className="text-gray-600 mt-2">Enter the OTP sent to your registered email</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex justify-center gap-4 mb-4">
            {otp.map((data, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={data}
                onChange={(e) => onChange(e, index)}
                className={`w-14 h-14 text-center text-xl font-medium border rounded-lg focus:ring-2 focus:ring-blue-500 transition duration-200 ${error ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="0"
              />
            ))}
          </div>

          {error && <p className="text-red-500 text-sm text-center">{error}</p>}

          <div className="flex justify-center items-center gap-4">
            <span className="text-gray-600 font-medium">{formatTime(timer)}</span>
            <button
              type="button"
              onClick={handleResendOtp}
              disabled={isResendDisabled}
              className={`flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium transition duration-200 ${isResendDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              Resend OTP
            </button>
          </div>

          <button
            type="submit"
            disabled={otp.includes('') || timer === 0}
            className={`w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-medium ${otp.includes('') || timer === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          >
            Verify
          </button>
        </form>
      </div>
    </div>
  );
};

export default Otp;